import { Button as ShadcnButton } from "../ui/button";
import { cn } from "../../lib/utils";
import { ButtonProps } from "../../types/components";

/**
 * Consistent Button component with standardized props and styling
 */
function Button({
  variant = "primary",
  size = "md",
  className,
  children,
  disabled = false,
  onClick,
  type = "button",
  ...props
}: ButtonProps) {
  const variantMap = {
    primary: "default",
    secondary: "secondary",
    outline: "outline",
    ghost: "ghost",
  } as const;

  const sizeMap = {
    sm: "sm",
    md: "default",
    lg: "lg",
  } as const;

  return (
    <ShadcnButton
      variant={variantMap[variant]}
      size={sizeMap[size]}
      className={cn(
        "transition-all duration-200",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      disabled={disabled}
      onClick={onClick}
      type={type}
      {...props}
    >
      {children}
    </ShadcnButton>
  );
}

export default Button;
